import React, { useEffect, useRef } from 'react';
import D3BoxPlot from './D3BoxPlot';
import { useTranslation } from 'react-i18next';

const BoxPlot: React.NamedExoticComponent<{
  data: { x: string; y: number[]; z: number }[] | undefined | any;
  benchmarkingValue: any;
}> = React.memo(({ data, benchmarkingValue }) => {
  const ref:any = useRef();
  const [t] = useTranslation();
  useEffect(() => {
    if (ref.current) {
      ref.current.innerHTML = '';
      D3BoxPlot(ref.current, data, t, benchmarkingValue);
    }
  });
  return <div ref={ref} style={{ height: '300px', overflowY: 'auto' }} />;
});
export default BoxPlot;
